<template>
    <section id="login-form" class="container">
        <div class="row">
            <div class="col-md-10">
                <h2>Reset your password</h2>
                <p>Type the email you used to sign up and hit the 'reset your password' button.</p>
                <p>We'll send you an email with instructions on how to set a new one up.</p>
                <form class="my-3">
                    <div class="form-row">
                        <TextInput
                            inputId="email"
                            v-model="formData.email"
                            labelText="Email address"
                            :wrapperClasses="['col-md-6']"
                            :isRequired="false"
                            :optionalFlag="false"
                            :validation="[{type:'email',msg:'Please provide a valid email'}]"
                        />
                    </div>

                    <button
                        class="btn-mobile btn btn-primary"
                        type="submit"
                        @click.prevent="resetPasswordEmail"
                    >Reset your password</button>
                    <div class="spinner-container" v-if="loading">
                        <div class="spinner"></div>
                    </div>
                </form>
                <div class="new-account">
                    <div class="new-account__header">Don't have an account yet?</div>
                    <router-link to="/create-account">Create an account</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";

export default {
    name: "forgot-password-form",
    components: {
        TextInput
    },
    data() {
        return {
            formData: {
                email: ""
            },
            submitted: false,
            loading: false
        };
    },
    methods: {
        resetPasswordEmail() {
            // Send password reset email
            this.loading = true;
            const data = JSON.stringify(this.formData.email);
            this.$store
                .dispatch("AUTH_PASSWORD_RESET_EMAIL", data)
                .then(resp => {
                    this.$emit("email-sent", resp);
                    this.loading = false;
                })
                .catch(err => {
                    // eslint-disable-next-line
                    console.error(err);
                });
        }
    }
};
</script>